var $ = require('jquery');
require('slick-carousel');

var slider = $('.product-slider .slider');

$(function() {
    $(slider).on('init', function(event, slick, direction){
        initDots(this);
        /*$(slider).on('breakpoint', function(event, slick, direction){
            initDots(this);
        });*/
    });

    $(slider).each(function() {
        $(this).slick({
            centerMode: true,
            slidesToShow: 1,
            centerPadding: '50px',
            variableWidth: true,
            speed: 400,
            autoplay: false,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            arrows: false,
            focusOnSelect: true,
            infinite: true,
        });
    });


});


function initDots(slider) {
    var dotColors = $(slider).data('dot-colors');
    if (dotColors.length > 0) {
        $(slider).find('.slick-dots button').each(function(i) {
            if (i < dotColors.length) {
                if (dotColors[i]['main_color'] && dotColors[i]['main_color']) {
                    $(this).css({
                        'background-color': dotColors[i]['main_color'],
                        'border-color': dotColors[i]['secondary_color']
                    });
                } else if (dotColors[i]['main_color']) {
                    $(this).css({
                        'background-color': dotColors[i]['main_color']
                    });
                }
            }
        });
    }    
}